<template>
  <v-dialog
    v-model="dialog"
    :width="620"
  >
    <v-card>
      <v-card-title primary-title>
        <div class="headline">Configuración</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-layout row>
            <v-flex xs12>
              <v-autocomplete
                :items="vehicles"
                v-model="vehicleSelect"
                return-object
                item-text="plate"
                prepend-icon="directions_car"
                label="Vehículos"
                single-line
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <v-dialog
                v-model="dateDialog"
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Día"
                  v-model="date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  locale="es-co"
                  v-model="date"
                  :allowed-dates="allowedDates"
                  scrollable
                  autosave
                />
              </v-dialog>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <v-dialog
                v-model="startTimeDialog"
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Desde"
                  v-model="startTime"
                  prepend-icon="access_time"
                  readonly
                ></v-text-field>
                <v-time-picker v-model="startTime" autosave/>
              </v-dialog>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <v-dialog
                v-model="finishTimeDialog"
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Hasta"
                  v-model="finishTime"
                  prepend-icon="access_time"
                  readonly
                ></v-text-field>
                <v-time-picker v-model="finishTime" autosave/>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          flat
          @click.native="dialog = false"
        >Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
  name: 'config-dialog',
  props: {
    vehicles: Array,
    selectedVehicle: Object,
    startDate: Number,
    finishDate: Number
  },
  data: function () {
    return {
      dialog: false,
      dateDialog: false,
      startTimeDialog: false,
      finishTimeDialog: false,
      date: null,
      startTime: null,
      finishTime: null,
      vehicleSelect: null
    }
  },
  computed: {
    allowedDates: function () {
      const min = moment().subtract(6, 'months').toDate().toISOString().substr(0, 10)
      const max = moment().toDate().toISOString().substr(0, 10)
      return { min, max }
    },
    startDateAndTime: function () {
      if (!this.date || !this.startTime) {
        return null
      }
      return moment(`${this.date} ${this.startTime}`, 'YYYY-MM-DD h:mmA')
    },
    finishDateAndTime: function () {
      if (!this.date || !this.finishTime) {
        return null
      }
      return moment(`${this.date} ${this.finishTime}`, 'YYYY-MM-DD h:mmA')
    }
  },
  watch: {
    vehicleSelect: function (vehicleSelect) {
      this.$emit('update:selectedVehicle', vehicleSelect)
    },
    date: function () {
      this.getStartDateAndTime()
      this.getFinishDateAndTime()
    },
    startTime: function () {
      this.getStartDateAndTime()
    },
    finishTime: function () {
      this.getFinishDateAndTime()
    }
  },
  methods: {
    getStartDateAndTime: function () {
      const startDateAndTime = this.startDateAndTime
      if (!startDateAndTime) {
        this.$emit('update:startDate', null)
      } else {
        this.$emit('update:startDate', startDateAndTime.valueOf())
      }
    },
    getFinishDateAndTime: function () {
      const finishDateAndTime = this.finishDateAndTime
      if (!finishDateAndTime) {
        this.$emit('update:finishDate', null)
      } else {
        this.$emit('update:finishDate', finishDateAndTime.valueOf())
      }
    },
    open: function () {
      this.dialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Travels/ConfigDialog.vue